import React from "react";
import InputField from "./InputField";
import { useFormContext } from "react-hook-form";

const EmailField = ({ attribute }) => {
  const { watch } = useFormContext();

  const emailVerified = watch("emailVerified");

  return (
    <InputField
      attribute={{
        ...attribute,
        disabled: emailVerified,
        className: emailVerified ? 'disabled-field' : ''
      }}
    />
  );
};

export default EmailField;
